// services/initialAssessmentService.ts
import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import {
  BREATHING_OBSERVATION,
  GCS_OBSERVATION,
  GENERAL_EXAMINATION_OBSERVATION,
  GENERAL_INITIAL_OBSERVATION,
  GET_COMPOSITION,
  SAVE_COMPOSITION,
} from '../utils/Endpoints'

const API_BASE = process.env.REACT_APP_API_GATEWAY_URL

const getAuthHeaders = () => {
  const token = KeycloakService.getToken()
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
}

// API Calls

export const saveComposition = async (patientId: string) => {
  try {
    const response = await axios.post(
      `${API_BASE}${SAVE_COMPOSITION}?patientId=${patientId}`,
      {},
      getAuthHeaders()
    )
    const { data, success, message } = response?.data || {}
    if (success) return { success: true, data, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postGeneralInitialObservation = async (
  data: any,
  compositionId: string,
  patientId: string
) => {
  try {
    const response = await axios.post(
      `${API_BASE}${GENERAL_INITIAL_OBSERVATION}?compositionId=${compositionId}&patientId=${patientId}`,
      data,
      getAuthHeaders()
    )
    const { data: responseData, success, message } = response?.data || {}
    if (success) return { success: true, data: responseData, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postBreathingObservation = async (
  data: any,
  compositionId: string,
  patientId: string,
  observationId1: string
) => {
  try {
    const response = await axios.post(
      `${API_BASE}${BREATHING_OBSERVATION}?compositionId=${compositionId}&patientId=${patientId}&observationId1=${observationId1}`,
      data,
      getAuthHeaders()
    )
    const { data: responseData, success, message } = response?.data || {}
    if (success) return { success: true, data: responseData, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postGcsObservation = async (
  data: any,
  compositionId: string,
  patientId: string,
  observationId1: string,
  observationId2: string
) => {
  try {
    const response = await axios.post(
      `${API_BASE}${GCS_OBSERVATION}?compositionId=${compositionId}&patientId=${patientId}&observationId1=${observationId1}&observationId2=${observationId2}`,
      data,
      getAuthHeaders()
    )
    const { data: responseData, success, message } = response?.data || {}
    if (success) return { success: true, data: responseData, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const postGeneralExaminationObservation = async (
  data: any,
  compositionId: string,
  patientId: string,
  observationId1: string,
  observationId2: string,
  observationId3: string,
  medicationStatementId1: string,
  medicationStatementId2: string
) => {
  try {
    const url = `${API_BASE}${GENERAL_EXAMINATION_OBSERVATION}?compositionId=${compositionId}&patientId=${patientId}&observationId1=${observationId1}&observationId2=${observationId2}&observationId3=${observationId3}&medicationStatementId1=${medicationStatementId1}&medicationStatementId2=${medicationStatementId2}`
    const response = await axios.post(url, data, getAuthHeaders())
    const { data: responseData, success, message } = response?.data || {}
    if (success) return { success: true, data: responseData, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getCompositionByPatientId = async (patientId: string) => {
  try {
    const response = await axios.get(
      `${API_BASE}${GET_COMPOSITION}?patientId=${patientId}`,
      getAuthHeaders()
    )
    const { data, success, message } = response?.data || {}
    if (success) return { success: true, data, message }
    return { success: false, data: null, message }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}
